import { PlusIcon } from '@langchain/untitled-ui-icons';

import { useState } from 'react';

import { Button, IconButton } from '@/design-system';
import { useHostRevisions } from '@/hooks/useSwr';
import { HostProjectSchema } from '@/types/schema.ts';

import { RevisionCrudModal } from './RevisionCrudModal';

export function RevisionCrudModalWithButton({
  hostProject,
  compact,
}: {
  hostProject: HostProjectSchema;
  compact?: boolean;
}) {
  const {
    id: hostProjectId,
    metadata,
    resource,
    container_spec,
    repo_branch,
  } = hostProject;

  const { image_source, shareable } = metadata;

  const [open, setIsOpen] = useState(false);

  // retrieve latest revision
  const { data: rows, isLoading } = useHostRevisions(hostProjectId, {
    limit: 1,
    offset: 0,
  });
  const revisionPending = rows == null && isLoading;
  const latestRevision = rows?.[0];

  return (
    <>
      {compact ? (
        <IconButton
          icon={PlusIcon}
          label="New Revision"
          onClick={() => setIsOpen(true)}
          disabled={revisionPending}
          color="secondary"
        />
      ) : (
        <Button
          size="sm"
          onClick={() => setIsOpen(true)}
          variant="outlined"
          color="secondary"
          disabled={revisionPending}
          leftDecorator={PlusIcon}
        >
          New Revision
        </Button>
      )}
      {open && !revisionPending && (
        <RevisionCrudModal
          hostProjectId={hostProjectId}
          imageSource={image_source ?? 'github'}
          currentRepoPath={latestRevision?.repo_path}
          currentRepoCommit={repo_branch ?? 'main'}
          currentImagePath={latestRevision?.image_path}
          currentEnvVars={resource?.latest_revision?.env_vars ?? []}
          currentShareable={!!shareable}
          currentContainerSpec={container_spec}
          currentInstallCommand={latestRevision?.config?.install_command}
          currentBuildCommand={latestRevision?.config?.build_command}
          isOpen={open}
          doClose={() => setIsOpen(false)}
        />
      )}
    </>
  );
}
